import api from '../api/axios';
import { markOnline, markNetFail, rawOnline, setConfirmedOnline } from './netStatus';
import { offlineEnabled } from './offlineCache';

// ── Online ⇄ offline keçidlərinin mərkəzi monitoru ─────────────────────────────
// Əvvəl internetin gedib-gəldiyi yalnız təsadüfi bir API sorğusu alınanda/alınmayanda bilinirdi
// (C# WebView2-də navigator.onLine etibarsızdır) → keçid gec bilinirdi, sinxron gec başlayırdı.
// İndi: «Offline rejim» tikli tenantda aktiv ping (/api/health) — online-da 15 san, offline-da 3 san.
// Vəziyyət dəyişəndə BİR hadisə yayılır:
//   window 'net-status'  { online }        — status göstəriciləri (zolaq, yan menyu, sifariş ekranı)
//   window 'app-resync'  { reason }        — ekranlar məlumatı yenidən yükləsin:
//        reason='offline' → dərhal (keşdən oxusunlar)
//        reason='online'  → OfflineBanner növbəni sinxronlaşdırdıqdan SONRA (serverdən təzə)

const PING_ONLINE = 15000;
const PING_OFFLINE = 3000;
const PING_TIMEOUT = 4000;

let state = rawOnline();
let timer = null;
let started = false;

const emit = (name, detail) => {
    try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch { /* ignore */ }
};

export const requestResync = (reason) => emit('app-resync', { reason });

// Axios da markOnline/markNetFail edir → statusu tez-tez yoxla, dəyişibsə yay.
// online → offline keçidi YALNIZ ping ilə təsdiqlənir (confirmed=true): tək bir yavaş/uğursuz sorğu
// sistemi səhvən offline-a salıb ekranları keşə keçirməsin.
let confirming = false;
const check = (confirmed = false) => {
    const now = rawOnline();
    if (now === state) return;
    if (!now && !confirmed) {
        if (!confirming) { confirming = true; probeNow(); }
        return;
    }
    state = now;
    setConfirmedOnline(now);
    emit('net-status', { online: now });
    if (!now) requestResync('offline'); // online qayıdanda resync OfflineBanner flush-dan sonra yayır
};

const healthUrl = () => {
    const base = String(api.defaults.baseURL || '/api').replace(/\/+$/, '');
    return `${base}/health?_=${Date.now()}`;
};

const probe = async () => {
    if (offlineEnabled()) {
        const ctrl = new AbortController();
        const t = setTimeout(() => ctrl.abort(), PING_TIMEOUT);
        try {
            await fetch(healthUrl(), { cache: 'no-store', signal: ctrl.signal });
            markOnline();
        } catch {
            markNetFail();
        } finally {
            clearTimeout(t);
        }
        confirming = false;
        check(true);
    } else {
        confirming = false;
    }
    timer = setTimeout(probe, state ? PING_ONLINE : PING_OFFLINE);
};

// İndi yoxla (məs. axios şəbəkə xətası aldı → gözləmədən təsdiqlə)
export const probeNow = () => {
    if (timer) clearTimeout(timer);
    probe();
};

export const startNetMonitor = () => {
    if (started) return;
    started = true;
    setConfirmedOnline(state);
    setInterval(() => check(false), 1000);    // axios-un qeyd etdiyi dəyişiklikləri tut
    window.addEventListener('online', probeNow);
    window.addEventListener('offline', probeNow);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') probeNow(); });
    timer = setTimeout(probe, 2000);
};
